/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanionModel } from '../../models/companion-model';

export interface GetCompanions$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
  modalityId: number;
}

export function getCompanions(http: HttpClient, rootUrl: string, params: GetCompanions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanionModel>>> {
  const rb = new RequestBuilder(rootUrl, getCompanions.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.path('modalityId', params.modalityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanionModel>>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getCompanions.PATH = '/api/systemoverview/companions/{systemSerialNumber}/{systemMaterialNumber}/{modalityId}';
getCompanions.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getCompanions.ROOTURL = '/portal';
